import { GOOGLE_API_KEY } from '../helpers/constants';
import type { LoaderOptions } from '../google/loader/googleMapsLoader';
import { GoogleMapsLoader } from '../google/loader/googleMapsLoader';

import { mapPrediction } from './helpers';
import type { AutocompleteResult } from './types';

export class AutoCompleteService {
  private loadedService: Promise<google.maps.places.AutocompleteService>;

  constructor(language: LoaderOptions['language'] = 'en') {
    this.loadedService = new Promise((resolve, reject) => {
      const loader = new GoogleMapsLoader(GOOGLE_API_KEY, {
        language,
      });

      loader
        .loadLibrary('places')
        .then(({ AutocompleteService }) => resolve(new AutocompleteService()))
        .catch((error) => reject(error));
    });
  }

  public async getAutocompleteSuggestions(
    input: string
  ): Promise<AutocompleteResult[]> {
    const request: google.maps.places.AutocompletionRequest = {
      input,
    };

    const service = await this.loadedService;
    return new Promise((resolve, reject) => {
      service.getPlacePredictions(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          const mappedResults = results.map(mapPrediction);
          resolve(mappedResults);
        } else {
          reject(
            new Error(
              `GetPlacePredictions was not successful for the following reason: ${status}`
            )
          );
        }
      });
    });
  }
}
